/* INNOR — ventes additionnelles DANS LE TIROIR PANIER (25/08/2026).

   Pourquoi ici et pas dans innor-ensemble.js : celui-là vit sur la fiche
   produit et parle d'une tenue qu'on est en train de regarder. Le tiroir, lui,
   ne connaît que le panier — il est ouvert depuis n'importe quelle page, y
   compris une page où aucun produit n'est affiché. Les deux moteurs ne
   partagent ni leur déclencheur ni leur état.

   CE QU'IL PROPOSE, ET SEULEMENT ÇA. Les règles sont celles de l'Admin, pas
   des idées de thème :
     1 pièce au panier  → la 2e déclenche le Silver Signature offert
     2 pièces au panier → la 3e déclenche le cadeau surprise (code de remise)
     3 pièces           → plus rien à vendre, on félicite et on se tait
   Le collier ne compte JAMAIS comme une pièce : c'est le cadeau, l'ajouter ne
   fait pas franchir de palier. Le compter aurait proposé une troisième pièce
   à quelqu'un qui n'en a que deux, pour une récompense qu'il n'obtiendrait pas.

   MOBILE D'ABORD. Les tailles sont TOUJOURS visibles, jamais derrière un
   dépliant : dans un tiroir de 390 px, un accordéon coûte un geste et une
   attente d'animation pour cacher six pastilles qui tiennent sur une ligne.
   Le bouton reste inerte tant qu'aucune taille n'est choisie — un ajout qui
   échoue à cet endroit-là fait perdre la vente, pas seulement le clic.

   PLUS DE BANNIÈRE. Les pièces proposées sont des LIGNES, posées à la suite
   de celles du panier : elles sont donc visibles là où on regarde déjà, sans
   qu'un bandeau ait besoin d'aller les annoncer en tête du tiroir. Et la
   promesse n'a plus besoin d'une bannière à photo et à sceau qui prenait la
   moitié de l'écran — la jauge la porte, en trois pastilles. */
(function () {
  'use strict';

  var conf = null;
  try {
    var brut = document.querySelector('[data-cart-upsell-config]');
    if (brut) conf = JSON.parse(brut.textContent);
  } catch (e) {
    conf = null;
  }
  if (!conf || !conf.pieces || !conf.pieces.length) return;

  var hote = document.querySelector('[data-cart-upsell]');
  if (!hote) return;

  function euros(cents) {
    return window.INNOR && INNOR.formatMoney ? INNOR.formatMoney(cents)
      : Math.round(cents / 100) + ' €';
  }

  /* Les handles présents au panier. /cart.js ne renvoie pas `handle` sur la
     ligne mais `url` (/products/le-handle?variant=…) : on le lit là, avec un
     repli sur product_title pour les paniers de préview. */
  function handleDeLaLigne(it) {
    if (it.handle) return it.handle;
    /* /cart.js ne renvoie pas `handle` sur la ligne mais `url`
       (/products/le-handle?variant=…) : on le lit là. */
    var m = it.url ? String(it.url).match(/\/products\/([^?#/]+)/) : null;
    return m ? m[1] : null;
  }

  function handlesDuPanier(etat) {
    var vus = {};
    (etat.items || []).forEach(function (it) {
      var h = handleDeLaLigne(it);
      if (h) vus[h] = true;
    });
    return vus;
  }

  /* LA JAUGE SUIT SHOPIFY, PAS L'INVERSE (18/09/2026, décision finale).
     La remise Admin « Pendentif Signature » est une quantité minimale (2) sur
     la collection RONIN : Shopify ne sait pas distinguer 2 pantalons de
     veste+pantalon, et zéro un Silver Signature dès que ce seuil est atteint
     — y compris une ligne payée par le client, sans que le thème puisse s'y
     opposer (limite native, pas un bug). Compter les pièces en HANDLES
     DISTINCTS ici afficherait une jauge qui promet le contraire de ce que la
     caisse fait réellement. On compte donc en QUANTITÉ, pour que le tiroir
     ne mente jamais sur ce qui va se passer au paiement. */
  function quantitePieces(etat) {
    var handles = {};
    conf.pieces.forEach(function (p) { handles[p.handle] = true; });
    return (etat.items || []).reduce(function (n, it) {
      var h = handleDeLaLigne(it);
      return handles[h] ? n + (it.quantity || 0) : n;
    }, 0);
  }

  function pastilles(piece) {
    /* Une seule variante intitulée « Default Title » n'est pas une taille :
       c'est un produit sans déclinaison. On l'ajoute directement au lieu de
       demander de choisir entre une seule option. */
    var vraies = piece.tailles.filter(function (t) { return t.titre !== 'Default Title'; });
    if (!vraies.length) return '';
    return '<div class="cart-line__tailles" data-tailles hidden>' + vraies.map(function (t) {
      return '<button type="button" class="cart-line__taille" data-variante="' + t.id + '"'
        + (t.dispo ? '' : ' disabled aria-label="' + t.titre + ' épuisée"') + '>'
        + t.titre + '</button>';
    }).join('') + '</div>';
  }

  /* UNE PIÈCE PROPOSÉE EST UNE LIGNE DE PANIER.

     Elle reprend `.cart-line` telle quelle : même vignette, même colonne de
     titre, même colonne de prix à droite. Seule la couleur du fond change, et
     l'action de droite : un « + » au lieu de « Retirer ». La version
     précédente en faisait une carte à part, avec ses propres vignettes, ses
     propres tailles et son propre bouton — trois objets de même poids sur le
     même écran, et l'œil n'avait plus de fil à suivre.

     Le « + » déplie les tailles DANS la ligne. Deux gestes en tout : j'ouvre,
     je choisis — et le choix ajoute, il n'y a pas de troisième bouton à
     viser. */
  function carte(piece) {
    var vraies = piece.tailles.filter(function (t) { return t.titre !== 'Default Title'; });
    var direct = vraies.length ? '' : ' data-variante-directe="'
      + (piece.tailles[0] ? piece.tailles[0].id : '') + '"';
    return '<div class="cart-line cart-line--propose" data-piece="' + piece.handle + '"' + direct + '>'
      + '<div class="cart-line__img">'
      + (piece.image ? '<img src="' + piece.image + '" alt="" loading="lazy">' : '')
      + '</div>'
      + '<div>'
      + '<p class="cart-line__title">' + piece.titre + '</p>'
      + '<p class="cart-line__meta">' + (vraies.length ? 'Choisir une taille' : 'À ajouter') + '</p>'
      + pastilles(piece)
      + '</div>'
      + '<div class="cart-line__action">'
      + '<span class="cart-line__price">' + euros(piece.prix) + '</span>'
      + '<button type="button" class="cart-line__plus" data-plus'
      + ' aria-expanded="false" aria-label="Ajouter ' + piece.titre + '">+</button>'
      + '</div>'
      + '</div>';
  }

  /* LA JAUGE DE PALIERS, reprise de la fiche produit (.ens-gauge).

     C'est elle, et plus une bannière, qui dit ce que le panier a débloqué et
     ce que débloque la pièce suivante. Une bannière pleine largeur avec photo
     et sceau prenait la moitié de l'écran pour porter une phrase ; la jauge
     dit la même chose en trois pastilles, et elle le dit à TOUS les états au
     lieu de changer d'objet à chaque palier.

     Inversée par rapport à la fiche produit : là-bas la jauge est le seul
     objet SOMBRE d'une page claire, ici elle est bordée sur le fond sombre du
     tiroir. Dans les deux cas, c'est la surface qui ne ressemble à aucune
     autre autour d'elle. */
  function jauge(nb_pieces, total, complet) {
    var paliers = [{ compte: '1 pièce', gain: 'La pièce seule' }];
    if (conf.cadeau) {
      paliers.push({
        compte: '2 pièces',
        gain: conf.cadeau.titre + ' offert',
        /* L'ÉCONOMIE, EN CLAIR. Un cadeau annoncé sans son montant se lit
           comme un accessoire ; avec 80 € à côté, c'est une somme qu'on ne
           paie pas. Le pendentif a un prix fixe, le sien. */
        economie: conf.cadeau.prix,
        mention: 'offert'
      });
    }
    if (conf.surprise && conf.surprise.code) {
      /* Le cadeau surprise est un POURCENTAGE sur la commande : son montant
         n'est pas fixe, il grandit avec le panier. On le calcule sur le total
         RÉEL en cours (celui que Shopify vient de renvoyer, remises comprises)
         plutôt que sur une somme théorique — et le taux vient du réglage, pas
         d'une constante : le jour où l'Admin passe à 15 %, le tiroir suit. */
      var taux = conf.surprise.pourcent || 10;
      paliers.push({
        compte: '3 pièces',
        gain: conf.surprise.titre,
        economie: Math.round((total || 0) * taux / 100),
        mention: '−' + taux + ' %',
        /* SECRET, ET INACCESSIBLE TANT QUE LE PALIER N'EST PAS ATTEINT
           (corrigé le 07/09/2026 — le bouton « Découvrir » se voyait et se
           cliquait dès 1 pièce au panier, avant même d'avoir gagné le
           cadeau : plus rien à découvrir une fois les 3 pièces réellement
           réunies). Le montant existe dans le balisage dès maintenant, mais
           ni lui ni le bouton qui le révèle ne s'affichent avant que ce
           palier soit celui qu'on vient d'atteindre — voir plus bas,
           `rang <= atteint`. Le pendentif, lui, n'est pas un secret — sa
           valeur reste affichée dès le premier rendu, c'est tout son
           argument. */
        secret: true
      });
    }
    if (paliers.length < 2) return '';

    var atteint = Math.min(nb_pieces, paliers.length);
    if (atteint >= 3 && !complet) atteint = 2;
    /* La barre court de CENTRE de première pastille à CENTRE de dernière : le
       remplissage est donc une fraction des intervalles, pas des paliers. */
    var rempli = paliers.length > 1
      ? Math.max(0, (atteint - 1) / (paliers.length - 1)) * 100 : 0;

    return '<div class="cart-jauge" style="--gauge-steps: ' + paliers.length + '">'
      + '<div class="cart-jauge__rail">'
      + '<div class="cart-jauge__track" aria-hidden="true">'
      + '<span class="cart-jauge__fill" style="width:' + rempli + '%"></span></div>'
      + '<ol class="cart-jauge__steps">'
      + paliers.map(function (p, i) {
          var rang = i + 1;
          var etat = rang <= atteint ? ' is-done' : (rang === atteint + 1 ? ' is-next' : '');
          if (rang === atteint) etat += ' is-current';
          return '<li class="cart-jauge__step' + etat + '">'
            + '<span class="cart-jauge__dot" aria-hidden="true"></span>'
            + '<span class="cart-jauge__count">' + p.compte + '</span>'
            + '<span class="cart-jauge__reward">' + p.gain + '</span>'
            + (p.economie
                ? (p.secret
                    ? (rang <= atteint
                        ? '<button type="button" class="cart-jauge__secret" data-reveler'
                          + ' aria-label="Découvrir la récompense">Découvrir</button>'
                          + '<span class="cart-jauge__gain" data-gain hidden>' + euros(p.economie)
                          + '<span class="cart-jauge__taux">' + p.mention + '</span></span>'
                        : '')
                    : '<span class="cart-jauge__gain">' + euros(p.economie)
                      + '<span class="cart-jauge__taux">' + p.mention + '</span></span>')
                : '')
            + '</li>';
        }).join('')
      + '</ol></div></div>';
  }

  /* Deux faits du dernier rendu, dont dépend ce que fait l'ajout. Relus à
     chaque rafraîchissement du panier plutôt que recalculés au clic : le clic
     doit obéir à ce qui est AFFICHÉ, pas à un état qui aurait pu changer
     entre-temps sans que la liste soit redessinée. */
  var nbPieces = 0;
  var cadeauDejaLa = false;

  /* ------------------------------------------------------------------
     RÉCONCILIATION DU CADEAU — la règle, tenue en une seule main.

     Le pendentif entrait au panier depuis TROIS chemins (la carte d'ensemble
     de la fiche, la fenêtre d'upsell, ce tiroir) et n'en sortait jamais tout
     seul. D'où les paniers signalés : deux pendentifs après un aller-retour
     sur la fiche, ou un pendentif offert resté seul avec une veste après
     qu'on ait retiré la deuxième pièce. Chaque chemin appliquait la règle de
     son côté, aucun ne la vérifiait.

     Elle est vérifiée ICI, à chaque changement de panier, quel que soit le
     chemin qui l'a provoqué :

         quantité de pendentif au panier == (pièces >= 2) ? 1 : 0

     Les chemins peuvent continuer à ajouter le pendentif — c'est même
     nécessaire, une remise « achetez 2, obtenez Y » ne crée pas la ligne. Ils
     ne peuvent simplement plus se tromper : ce qui est en trop repart, ce qui
     manque arrive.
     ------------------------------------------------------------------ */
  var reconciliationEnCours = false;
  var echecsAjoutCadeau = 0;

  /* MARQUEUR DE LIGNE, PAS SEULEMENT LE HANDLE (06/09/2026).

     Le pendentif se vend aussi TOUT SEUL — à l'unité, ou par deux via l'offre
     Duo de sa propre fiche. Filtrer les lignes-cadeau sur le seul handle
     confondait les deux : un pendentif payé, ajouté par « Ajouter au panier »
     ou « Ajouter le duo », se faisait immédiatement remettre à 0 par cette
     même réconciliation, croyant nettoyer un cadeau orphelin (nb_pieces == 0
     ⇒ voulu == 0 ⇒ la ligne du pendentif, quelle qu'elle soit, est vidée).

     Chaque geste qui ajoute VRAIMENT le cadeau (ici, la fenêtre d'upsell,
     la carte d'ensemble de la fiche) pose cette propriété de ligne. Un
     pendentif acheté pour lui-même ne la porte jamais, donc n'entre plus
     dans ce calcul — la réconciliation ne voit plus que ce qu'elle a
     elle-même à gérer. */
  var CLE_MARQUEUR_CADEAU = '_Cadeau ensemble';

  function lignesDuCadeau(etat) {
    if (!conf.cadeau) return [];
    return (etat.items || []).filter(function (it) {
      return handleDeLaLigne(it) === conf.cadeau.handle
        && it.properties && it.properties[CLE_MARQUEUR_CADEAU];
    });
  }

  /* PAS DE CADEAU EN PLUS D'UN PENDENTIF DÉJÀ PAYÉ (18/09/2026).
     Le pendentif se vend aussi seul, ou par deux via l'offre Duo de sa propre
     fiche : 2 pantalons (cadeau) + un Duo de pendentifs payés donnait 3
     pendentifs au panier pour 2 souhaités. Dès qu'une ligne de pendentif SANS
     le marqueur cadeau est présente, la personne a déjà ce qu'elle voulait —
     on n'en ajoute plus, gratuit ou non. */
  function pendentifPayeDejaLa(etat) {
    if (!conf.cadeau) return false;
    return (etat.items || []).some(function (it) {
      return handleDeLaLigne(it) === conf.cadeau.handle
        && !(it.properties && it.properties[CLE_MARQUEUR_CADEAU])
        && (it.quantity || 0) > 0;
    });
  }

  function reconcilier(etat, nb_pieces) {
    if (reconciliationEnCours) return false;
    if (!conf.cadeau || !conf.cadeau.variante) return false;

    var lignes = lignesDuCadeau(etat);
    var qte = lignes.reduce(function (n, l) { return n + (l.quantity || 0); }, 0);
    var voulu = (nb_pieces >= 2 && !pendentifPayeDejaLa(etat)) ? 1 : 0;
    if (qte === voulu) return false;

    /* Un ajout qui échoue (pendentif épuisé) ne doit pas être retenté à chaque
       événement de panier : on abandonne après deux essais et le tiroir
       continue de fonctionner sans lui. */
    if (qte < voulu && echecsAjoutCadeau >= 2) return false;

    reconciliationEnCours = true;
    var travail;
    if (qte < voulu) {
      travail = INNOR.cart.addMany([{
        id: conf.cadeau.variante, quantity: 1,
        properties: (function () { var p = {}; p[CLE_MARQUEUR_CADEAU] = 'oui'; return p; })()
      }]).catch(function () { echecsAjoutCadeau++; });
    } else {
      /* Plusieurs lignes de pendentif peuvent coexister (tailles ou
         propriétés différentes selon le chemin d'ajout) : on garde la
         première à la quantité voulue et on vide les autres, en série —
         /cart/change.js renumérote les lignes, deux appels concurrents se
         marcheraient dessus. */
      travail = lignes.reduce(function (chaine, ligne, i) {
        return chaine.then(function () {
          return INNOR.cart.change(ligne.key, i === 0 ? voulu : 0);
        });
      }, Promise.resolve()).catch(function () {});
    }

    travail.then(function () { reconciliationEnCours = false; });
    return true;
  }

  function rendre(etat) {
    if (!etat) return;
    var vus = handlesDuPanier(etat);
    var cadeauHandle = conf.cadeau ? conf.cadeau.handle : null;
    cadeauDejaLa = !!(cadeauHandle && vus[cadeauHandle]);

    var manquantes = conf.pieces.filter(function (p) {
      return !vus[p.handle] && p.handle !== cadeauHandle;
    });
    /* `complet` reste sur les PIÈCES DISTINCTES : le cadeau surprise à 3
       (palier interne au thème, aucune remise Shopify derrière) exige la
       vraie tenue réunie. Le cadeau à 2, lui, suit Shopify — voir
       `quantitePieces` plus haut. */
    var complet = manquantes.length === 0;
    nbPieces = quantitePieces(etat);

    /* On corrige AVANT de dessiner. La correction relance un événement de
       panier, donc un second rendu avec l'état juste : inutile de peindre
       l'état intermédiaire, il serait faux une fraction de seconde. */
    if (reconcilier(etat, nbPieces)) return;

    if (!etat.item_count || !nbPieces) {
      hote.hidden = true;
      hote.innerHTML = '';
      return;
    }

    /* Tenue complète : plus de pièce à proposer, mais le code de la
       récompense à remettre. Sans ça, celui qui a réuni les trois pièces
       depuis le tiroir n'apprenait jamais l'existence du code — le ticket
       mystère ne s'ouvre que sur la fiche produit. */
    var codeDispo = conf.surprise && conf.surprise.code;

    hote.hidden = false;
    hote.innerHTML =
      manquantes.map(carte).join('')
      + '<p class="form-error" data-up-erreur aria-live="polite"></p>'
      + jauge(nbPieces, etat.total_price, complet)
      + (complet && codeDispo
          ? '<div class="cart-jauge__code"><span>' + conf.surprise.code + '</span>'
            + '<a href="' + conf.surprise.url + '">Appliquer</a></div>'
          : '');
  }

  /* Un seul écouteur, délégué : le contenu est réécrit à chaque
     rafraîchissement du panier, des écouteurs posés sur les boutons
     mourraient avec eux. */
  document.addEventListener('click', function (e) {
    /* Le « + » déplie les tailles dans la ligne. Il ne fait que ça : c'est le
       choix de la taille qui ajoute, un pas plus loin. */
    var plus = e.target.closest('[data-plus]');
    if (plus) {
      var ligne = plus.closest('[data-piece]');
      var tailles = ligne.querySelector('[data-tailles]');
      if (!tailles) { ajouter(ligne, ligne.dataset.varianteDirecte, plus); return; }
      var ouvert = tailles.hidden;
      /* Une seule ligne dépliée à la fois : deux menus ouverts dans un tiroir
         de 390 px, et la commande repart hors de l'écran. */
      hote.querySelectorAll('[data-tailles]').forEach(function (t) { t.hidden = true; });
      hote.querySelectorAll('[data-plus]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.textContent = '+';
      });
      tailles.hidden = !ouvert;
      plus.setAttribute('aria-expanded', String(ouvert));
      plus.textContent = ouvert ? '×' : '+';
      return;
    }

    /* La révélation du cadeau surprise. Un aller simple : une fois montré, il
       le reste jusqu'au prochain rendu du panier — le rouvrir et le refermer
       en boucle ne rendrait pas le secret. */
    var reveler = e.target.closest('[data-reveler]');
    if (reveler) {
      var gain = reveler.parentElement.querySelector('[data-gain]');
      if (gain) gain.hidden = false;
      reveler.remove();
      return;
    }

    var taille = e.target.closest('.cart-line__taille');
    if (taille) {
      var bloc = taille.closest('[data-piece]');
      ajouter(bloc, taille.dataset.variante, bloc.querySelector('[data-plus]'));
    }
  });

  function ajouter(ligne, variante, bouton) {
    if (!variante) return;
    var erreur = hote.querySelector('[data-up-erreur]');
    if (erreur) erreur.textContent = '';
    ligne.classList.add('est-en-cours');
    if (bouton) bouton.disabled = true;

    /* LE PENDENTIF PART DANS LE MÊME APPEL, quand c'est cette pièce-ci qui
       fait passer le panier à deux.

       Une réduction « achetez 2 pièces, obtenez le pendentif offert » NE CRÉE
       PAS la ligne : elle ne fait qu'en annuler le prix. Sans pendentif au
       panier, il n'y a rien à annuler et la promesse affichée par la jauge
       tombe à la caisse. C'est le même geste que la carte d'ensemble de la
       fiche produit et que la fenêtre d'upsell — les trois chemins doivent
       constituer le même panier.

       addMany et non deux add() : /cart/add.js traite le lot d'un bloc, donc
       on ne peut pas se retrouver avec la pièce sans le cadeau si le second
       appel échoue. */
    var lot = [{ id: parseInt(variante, 10), quantity: 1 }];
    if (nbPieces === 1 && conf.cadeau && conf.cadeau.variante && !cadeauDejaLa) {
      var propsCadeau = {};
      propsCadeau[CLE_MARQUEUR_CADEAU] = 'oui';
      lot.push({ id: conf.cadeau.variante, quantity: 1, properties: propsCadeau });
    }

    INNOR.cart.addMany(lot).catch(function (err) {
      if (erreur) erreur.textContent = err.message || 'Ajout impossible';
      ligne.classList.remove('est-en-cours');
      if (bouton) bouton.disabled = false;
    });
  }

  /* LA LIGNE DU CADEAU, DANS LE PANIER.

     innor-core.js dessine toutes les lignes de la même façon : il ne sait pas
     ce qu'est un cadeau, et il n'a pas à l'apprendre. C'est donc ici qu'on
     reprend la sienne pour lui donner ce que le client a demandé :
       - le prix du produit en petit, barré (sa valeur, qu'on ne paiera pas)
       - « OFFERT » en gros et en rouge à la place du 0 €
       - ni quantité ni « Retirer » : le pendentif suit la règle des deux
         pièces, il ne se retire pas à la main. Le retirer le faisait revenir
         à la seconde suivante par la réconciliation, ce qui ressemble à un
         bug alors que c'est la règle.

     `requestAnimationFrame` et non un appel direct : innor-panier.js est un
     script différé, son écouteur `innor:cart` est posé AVANT celui du noyau
     (posé, lui, au DOMContentLoaded). Au moment où le nôtre s'exécute, les
     lignes ne sont pas encore écrites. La frame suivante, si. */
  function marquerLigneCadeau() {
    if (!conf.cadeau) return;
    /* Le titre seul ne suffit plus (06/09/2026) : le pendentif se vend aussi
       à l'unité et par deux (offre Duo, propre fiche), avec le MÊME titre.
       Repérer uniquement par le nom habillait en « cadeau » — prix barré,
       plus de quantité, plus de bouton Retirer — un pendentif que le client
       vient de payer. Seule une ligne portant CLE_MARQUEUR_CADEAU (posée
       par les trois chemins qui ajoutent vraiment le cadeau : carte
       d'ensemble, fenêtre d'upsell, ce tiroir) doit recevoir ce traitement. */
    var etat = window.INNOR && INNOR.cart && INNOR.cart.state;
    var items = (etat && etat.items) || [];
    var lignes = document.querySelectorAll('[data-cart-lines] .cart-line');
    Array.prototype.forEach.call(lignes, function (ligne) {
      var titre = ligne.querySelector('.cart-line__title');
      if (!titre || titre.textContent.trim() !== conf.cadeau.titre) return;
      var item = items.filter(function (it) { return it.key === ligne.dataset.lineKey; })[0];
      if (!item || !item.properties || !item.properties[CLE_MARQUEUR_CADEAU]) return;
      if (ligne.classList.contains('cart-line--cadeau')) return;

      ligne.classList.add('cart-line--cadeau');
      var qte = ligne.querySelector('.cart-line__qty');
      if (qte) qte.remove();
      var retirer = ligne.querySelector('.cart-line__remove');
      if (retirer) retirer.remove();
      var prix = ligne.querySelector('.cart-line__price');
      if (prix) {
        prix.innerHTML = '<s>' + euros(conf.cadeau.prix) + '</s>'
          + '<strong class="cart-line__offert">Offert</strong>';
      }
    });
  }

  document.addEventListener('innor:cart', function (e) {
    rendre(e.detail);
    requestAnimationFrame(marquerLigneCadeau);
  });
  if (window.INNOR && INNOR.cart && INNOR.cart.state) rendre(INNOR.cart.state);
})();
